import { render, staticRenderFns } from "./Agenda.vue?vue&type=template&id=114f6c97&"
import script from "./Agenda.vue?vue&type=script&lang=js&"
export * from "./Agenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports